import { select } from '@ps/web-core-store';
import React from 'react';
import { useSelector } from 'react-redux';

import { Table } from '@swf/poker';
import type { TableColumnInstance } from '@swf/poker';

import { usePokerPowerPathWidget } from '../../../model';

const TableContainer: React.FC = () => {
  const { widgetDispatch, widgetSelect } = usePokerPowerPathWidget();
  const tournaments = useSelector(widgetSelect.getTournamentList);
  const loading = useSelector(widgetSelect.isLoading);
  const selectedRowId = useSelector(widgetSelect.getSelectedTournamentId);
  const sortRule = useSelector(widgetSelect.getTableSortRule);
  const isDesktopEmbedded = useSelector(select.device.isDesktopEmbedded);

  const handleColumnClick = (column: TableColumnInstance) =>
    widgetDispatch.setTableSortRule({ id: column.id, desc: !column.isSortedDesc });

  const handleRowClick = (tournamentId: number) =>
    widgetDispatch.setSelectedTournamentId(tournamentId);

  const handleRowDoubleClick = (tournamentId: number) => {
    if (!isDesktopEmbedded) return;
    window.starsweb?.app?.execute(`tournament/${tournamentId}`);
  };

  return (
    <Table
      data={tournaments}
      loading={loading}
      selectedRowId={selectedRowId}
      sortRule={sortRule}
      handleColumnClick={handleColumnClick}
      handleRowClick={handleRowClick}
      handleRowDoubleClick={handleRowDoubleClick}
    />
  );
};

export default TableContainer;
